import { gql } from 'graphql-tag'

export const VERIFY_PHONE_RELATED_TO_ORDER = gql`
  query verifyPhoneRelatedToOrder($orderId: String!, $phone: String!) {
    isOrderAssociatedWithPhoneNumber: isOrderAssociatedWithPhoneNumber(orderId: $orderId, phone: $phone)
  }
`
